import {
  FaHtml5,
  FaReact,
  FaNodeJs,
  FaSass,
  FaGitAlt,
  FaPython,
  FaDocker,
} from "react-icons/fa";
import { IoLogoCss3 } from "react-icons/io";
import { gsap, Power1 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {
  SiJavascript,
  SiExpress,
  SiMongodb,
  SiTypescript,
  SiRedux,
  SiPostman,
  SiTailwindcss,
  SiFigma,
  SiJest,
  SiNextdotjs,
  SiNestjs,
  SiSvelte,
  SiPostgresql,
} from "react-icons/si";
import { useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";

gsap.registerPlugin(ScrollTrigger);

const skills = [
  { title: "HTML5", className: "html", icon: <FaHtml5 /> },
  { title: "CSS3", className: "css", icon: <IoLogoCss3 /> },
  { title: "JavaScript", className: "javascript", icon: <SiJavascript /> },
  { title: "TypeScript", className: "typescript", icon: <SiTypescript /> },
  { title: "ReactJS", className: "react", icon: <FaReact /> },
  { title: "Next.js", className: "nextjs", icon: <SiNextdotjs /> },
  { title: "Svelte", className: "svelte", icon: <SiSvelte /> },
  { title: "TailwindCSS", className: "tailwind", icon: <SiTailwindcss /> },
  { title: "Sass", className: "sass", icon: <FaSass /> },
  { title: "Redux", className: "redux", icon: <SiRedux /> },
  { title: "Node.js", className: "node", icon: <FaNodeJs /> },
  { title: "Nest.js", className: "nestjs", icon: <SiNestjs /> },
  { title: "Express.js", className: "express", icon: <SiExpress /> },
  { title: "Python", className: "python", icon: <FaPython /> },
  { title: "MongoDB", className: "mongo", icon: <SiMongodb /> },
  { title: "PostgreSQL", className: "sql", icon: <SiPostgresql /> },
  { title: "Postman", className: "postman", icon: <SiPostman /> },
  { title: "Git", className: "git", icon: <FaGitAlt /> },
  { title: "Docker", className: "docker", icon: <FaDocker /> },
  { title: "Figma", className: "figma", icon: <SiFigma /> },
  { title: "Jest", className: "jest", icon: <SiJest /> },
];

const Skills = () => {
  let tools = useRef(null);
  const { ref, inView } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    const h1 = tools.querySelector("h1");
    const li = tools.querySelectorAll("li");

    gsap.fromTo(
      tools,
      1,
      { y: 44, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: tools,
          start: "top bottom-=10",
        },
      },
    );

    gsap.fromTo(
      h1,
      1,
      { y: 44, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut,
        scrollTrigger: {
          trigger: h1,
          start: "top bottom-=20",
        },
      },
    );
    gsap.fromTo(
      li,
      0.1,
      { y: 44, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        ease: Power1.easeOut,
        stagger: 0.08,
        scrollTrigger: {
          trigger: li,
          start: "top bottom-=30",
        },
      },
    );
  }, []);

  useEffect(() => {
    const menu = document.querySelectorAll(".nav-link");

    if (inView) {
      menu[2].classList.add("active");
      menu[0].classList.remove("active");
      menu[1].classList.remove("active");
      menu[3].classList.remove("active");
      menu[4].classList.remove("active");
    }
  }, [inView]);

  return (
    <>
      <main className="tools" id="skills">
        <div
          className="container "
          ref={(elem) => {
            tools = elem;
          }}
        >
          <div className="heading">
            <h1>Tools & Techs</h1>
          </div>
          <div className="content" ref={ref}>
            {[0, 7, 14].map((start) => (
              <SkillList key={start} skills={skills.slice(start, start + 7)} />
            ))}
          </div>
        </div>
      </main>
    </>
  );
};

const SkillList = ({ skills }) => (
  <ul>
    {skills.map(({ title, className, icon }) => (
      <li key={title} title={title}>
        <span className={className}>{icon}</span>
        {title}
      </li>
    ))}
  </ul>
);

export default Skills;
